import { YearView } from '@ui/components/DateView/DateView';

import styles from './Copyright.module.css';

export function Copyright() {
  const now = new Date();
  return (
    <section className={styles.copyright}>
      <p>
        © ChessOpen, <YearView date={now} />
      </p>
      <a href="https://chessopen.ru/termsofuse/" target="_blank" rel="noreferrer">
        Пользовательское соглашение
      </a>
      <a href="https://chessopen.ru/policy/" target="_blank" rel="noreferrer">
        Политика конфиденциальности
      </a>
      <a href="https://chessopen.ru/subscribe/" target="_blank" rel="noreferrer">
        Договор-оферта на приобретение услуг
      </a>
    </section>
  );
}
